import { get, localStorageManager, map } from '@libs/shared';
import { globalState } from '../models';
import { LOCAL_STORAGE, LOCAL_STORAGE_MIGRATE } from '../constants';

export const getChinaCode = () => {
    return '+86';
};

/**
 * 获取区号列表
 */
export const getAreaCodeList = () => {
    const areaCodeList = globalState.options?.calling_code_list;
    const currentLocale = globalState.localeKey!;
    return map(areaCodeList, ({ label, children }) => ({
        label,
        children: map(children, ({ value, text }) => ({
            value,
            text: get(text, currentLocale, get(text, globalState.defaultLocaleKey!, ''))
        }))
    }));
};

/**
 * 根据区号全称（地区名+区号）获取其中的区号
 * 比如由"中国 +86"获取其中的"+86"
 *
 * @param fullText 区号全称
 */
export const getCodeByFullText = (fullText: string) => {
    return `+${fullText.split('+')[1]}`;
};

/**
 * 通过手机号获取区号（手机号不带区号时取缓存内的，缓存内没有时取列表第一个）
 *
 * @param value 手机号
 * @param needCache 是否有缓存
 * @param phoneDelimiter 手机号和区号的分隔符，默认'-'
 */
export const getCodeByValue = (value: string, needCache?: boolean, phoneDelimiter = '-') => {
    const defaultAreaCode = needCache
        ? localStorageManager.getItemWithMigrate({
              oldKey: LOCAL_STORAGE.SIGN_IN.PHONE_AREA,
              newKey: LOCAL_STORAGE_MIGRATE.SIGN_IN_PHONE_AREA
          })
        : undefined;
    // 获取区号列表中的第一个区号
    const firstAreaCode = get(
        globalState.options,
        'calling_code_list.0.children.0.value',
        getChinaCode()
    );
    if (value?.indexOf(phoneDelimiter) >= 0) {
        return value.split(phoneDelimiter)[0];
    }
    return defaultAreaCode || firstAreaCode;
};
